/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import { formatDate, stringMin } from "../../core/function/function-generic";
import { ArrowSmallLeftIcon, CheckCircleIcon, ExclamationTriangleIcon, EyeIcon } from "@heroicons/react/24/outline";
import { RegExpValidator } from "../../core/regExp-generic";
import { userBusinessRoles } from "../../core/enum";
import { DropdownList } from "../DropdownList";
import { useSelector } from "react-redux";

interface ModalOperationProps {
    operationDetails: any;
    isOpen: boolean;
    closeModal: (isActive: boolean) => void;
    typeOperation: string;
    onGenerateNewKeys?: (action: string, data: any) => void;
    message?: string;
    onsubmitModal?: (data: any) => void;
  }

  export const ModalOperation: React.FC<ModalOperationProps> = (props) => {
    const { operationDetails, isOpen, closeModal, typeOperation, onGenerateNewKeys, message, onsubmitModal } =  props;

    const [actionForm, setActionForm] =useState((typeOperation)? typeOperation : 'info');

    const handleNameChange = (event: any) => {
        //const { name, value } = event.target;
        //setName(event.target.value);
    }

    const onSectionForm = (action: any) => {
        setActionForm(action)
        console.log(action)
    }

    const HeadInfo = (props: any) => {
        const { closeDialog, titleHead } = props;
        const titleHeader: any = {
            'Details Developers' : 'Details Developers',
            'invoice':'Transaction Information',
            'transactions':'Transaction Information',
            'info': 'Transaction Information',
            'addRoleUser': 'Invite new user',
        }

        return (
            <div className="flex items-start justify-between p-5 border-b 
            border-solid border-slate-200 rounded-t">
                <p className={`text-20-700`}>
                   {
                        titleHeader[titleHead]
                   }
                </p>
                <button
                    className="p-1 ml-auto bg-transparent border-0 text-black 
                    float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => closeDialog(false)}
                >
                    <span className="text-black h-6 w-6 text-2xl block outline-none">
                    ×
                    </span>
                </button>
            </div>
        )
    }

    const onPreviuse = (e: any) => {
        setActionForm(e);
    }

    const HeadReport = (props: any) => {
        const { closeDialog, onPreviuse } = props;
        return (
            <div className="p-6 mt-[-35px]">
                <div className="flex items-start w-full">
                    <button
                        className="p-1 ml-auto bg-transparent border-0 text-black
                        float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                        onClick={() => closeDialog(false)}
                    >
                        <span className="text-black h-6 w-6 text-2xl block outline-none">
                        ×
                        </span>
                    </button>
                </div>
                <div className='flex justify-between'>
                    <div className="fontPageTitle600 flex self-center">
                        <div className="self-center" onClick={()=>onPreviuse('info')}>
                            <ArrowSmallLeftIcon className='color-black w-[1.5rem] color-Logout cursor-pointer'/>
                        </div>
                        <div className="w-[500px]">
                            <h5 className="text-[20px]">
                                Transaction Information
                            </h5>
                        </div>
                    </div>
                    <div className="fontPageTitle600">
                        <div className="p-2.5 text-center">
                            <span className="fontPageTitle600">Date</span>
                            <p>{formatDate(operationDetails?.date)}</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const FormTransactionDetails = (props: any) => {
        const { onSectionForm } = props;
        return(
            <>
                <div className="relative p-6 flex-auto pr-[100px]">
                    <div className='flex justify-between'>
                        <div className="fontPageTitle600">User details</div>
                        <div className="fontPageTitle600 w-5/12">Transaction details</div>
                    </div>
                    <div className='flex justify-between'>
                        <div className="w-10/12">
                            <div className="mb-3 pt-0">
                                <label className="block mb-2 text-sm">Legal Name</label>
                                <input
                                    type="text"
                                    name='legalName'
                                    onChange={handleNameChange}
                                    value={operationDetails?.name}
                                    className="input-text fontPageTitle600 block w-full p-2.5"
                                />
                            </div>
                        </div>
                        <div className="flex justify-between ml-[40px]">
                            <div className="mb-3 pt-0">
                                <label className="block mb-2 text-sm">Type of transaction</label>
                                <input
                                    type="text"
                                    name='method'
                                    onChange={handleNameChange}
                                    value={operationDetails?.typeOperation}
                                    className="input-text fontPageTitle600 block w-full p-2.5"
                                />
                            </div>
                            <div className="mb-3 pt-0 ml-[20px]">
                                <label className="block mb-2 text-sm">Exchange Rate</label>
                                <input
                                    type="text"
                                    name='legalName'
                                    disabled
                                    onChange={handleNameChange}
                                    value={operationDetails?.rate}
                                    className="input-text fontPageTitle600 block w-full p-2.5"
                                />
                            </div>
                        </div>
                    </div>
                    <div className='flex justify-between'>
                        <div className="w-10/12">
                            <div className="mb-3 pt-0">
                                <label className="block mb-2 text-sm">Email</label>
                                <input
                                    type="text"
                                    name="email"
                                    onChange={handleNameChange}
                                    value={operationDetails?.email}
                                    className="input-text fontPageTitle600 block w-full p-2.5"
                                />
                            </div>
                        </div>
                        <div className="flex justify-between ml-[40px]">
                            <div className="mb-3 pt-0">
                                <label className="block mb-2 text-sm">From</label>
                                <input
                                    type="text"
                                    name='method'
                                    onChange={handleNameChange}
                                    value={operationDetails?.from}
                                    className="input-text fontPageTitle600 block w-full p-2.5"
                                />
                            </div>
                            <div className="mb-3 pt-0 ml-[20px]">
                                <label className="block mb-2 text-sm">To</label>
                                <input
                                    type="text"
                                    name='legalName'
                                    onChange={handleNameChange}
                                    value={operationDetails?.to}
                                    className="input-text fontPageTitle600 block w-full p-2.5"
                                />
                            </div>
                        </div>
                    </div>
                    <div className='flex justify-between'>
                        <div className="w-10/12">
                            <div className="mb-3 pt-0">
                                <label className="block mb-2 text-sm">Phone Number</label>
                                <input
                                    type="text"
                                    name="phoneNumber"
                                    onChange={handleNameChange}
                                    value={operationDetails?.phoneNumber}
                                    className="input-text fontPageTitle600 block w-full p-2.5"
                                />
                            </div>
                        </div>
                        <div className="w-[500px]"></div>
                    </div>
                    <div className='flex justify-between'>
                        <div className="w-10/12">
                            <div className="mb-3 pt-0">
                                <label className="block mb-2 text-sm">Country</label>
                                <input 
                                    type="text" 
                                    name="country"
                                    onChange={handleNameChange}
                                    value={operationDetails?.country}
                                    className="input-text fontPageTitle600 block w-full p-2.5"
                                />
                            </div>
                        </div>
                        <div className="w-[500px]"></div>
                    </div>
                </div> 
                <div className='relative p-6 flex-auto flex justify-between'>
                    <div className="flex">
                        <div className="p-2.5">
                            <span className="fontPageTitle600">Date</span>
                            <p>{formatDate(operationDetails?.date)}</p>
                        </div>
                        <div className="p-2.5">
                            <span className="fontPageTitle600">Id Transaction</span>
                            <p>{operationDetails?.idTransaction}</p>
                        </div>
                    </div>
                    <div className="self-center">
                        <button
                            className="fontPageTitle btn-alert-modal color-alert bg-transparent font-bold uppercase px-6 py-2 
                            text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                            type="button"
                            onClick={() => onSectionForm('report-1')}
                        >
                            <div className="flex font-size-12">
                                <div><ExclamationTriangleIcon className='color-alert w-[1.5rem] color-Logout cursor-pointer' /></div>
                                <div className="font-size-12">Report transaction</div>
                            </div> 
                        </button>
                    </div>
                </div>
            </>
        )
    }

    const FormReporttransaction = (props: any) => {
        const { onSectionForm } = props;
        return(
            <>
                <div className="relative p-6 flex-auto pr-[100px] ">
                    <div className='h-3/4'>
                        <div className="fontPageTitle600 text-[24px]">{operationDetails?.name}</div>
                        <div className="fontPageTitle600 w-5/12">
                            <label htmlFor="countries" className="block mb-2 text-[14px]">Motive of Report</label>
                            <select id="countries" className="border input-text border-gray-300  rounded-lg w-full p-2.5">
                                <option>Select</option>
                                <option value="US">Duplicate Transaction</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="flex justify-center w-full">
                    <button
                        className="fontPageTitle color-alert-report bg-transparent font-bold uppercase px-6 py-2 
                        text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                        type="button"
                        onClick={() => onSectionForm('report-1')}
                    >
                        <div className="flex font-size-12">
                            <div className="font-size-12">Report </div>
                        </div> 
                    </button>
                </div>
            </>
        )
    }

    const FormDatilsDev = (props: any) => {
        const { onGenerateNewKeys } = props;
        const [typeInput, setTypeInput] = useState('password');
        const [Input, setInput] = useState({
            nameBusiness: '',
            date: '',
            apiKey: '',
            apiSecret: '',
        });

        
        const handleChange = (event: any) =>{
            setInput((prevProps)=>({
                ...prevProps,
                [event.target.name] : event.target.value
            }))
        }

/*         const handleTogglePassword = () => {
            setTypeInput((prevTypeInput) =>
                  prevTypeInput === 'password' ? 'text' : 'password'
            );
        }; */

        return(
            <>
                <div className="grid gap-6 m-[20px] md:grid-cols-2 ">
                    <div>
                        <label className="block mb-2 text-[14px]">Name</label>
                        <input 
                            type="text"
                            name="nameBusiness" 
                            onChange={handleChange}
                            value={operationDetails?.name} 
                            disabled
                            className="input-text fontPageTitle600 block w-full p-2.5" 
                            placeholder="" 
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-[14px]">Date</label>
                        <input 
                            type="text" 
                            name="date"
                            onChange={handleChange}
                            disabled
                            value={operationDetails?.createdAt} 
                            className="input-text fontPageTitle600 block w-full p-2.5" 
                            placeholder="" 
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-[14px]">Country</label>
                        {operationDetails?.country} <span>{operationDetails?.countryName}</span>
                    </div>  
                </div>
                <div className="m-[20px]">
                    <div className="mb-2">
                        <label className="block mb-2 text-[14px]">Api Key</label>
                        <input 
                            type="text" 
                            name="apiKey"
                            onChange={handleChange}
                            value={operationDetails?.apiKey} 
                            className="input-text fontPageTitle600 block w-full p-2.5" 
                            placeholder="" 
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-[14px]">Api Secret</label>
                        <div className="w-full input-text flex pr-[10px]">
                            <input 
                                type="text" 
                                name="apiSecret"
                                onChange={handleChange}
                                value={(operationDetails.apiSecret)? operationDetails?.apiSecret : '*************'} 
                                className=" fontPageTitle600 block w-full p-2.5"
                                placeholder="" 
                            />
                            <EyeIcon className='w-[1.5rem] color-Logout cursor-pointer' onClick={()=>onGenerateNewKeys('generateKeysShow', operationDetails)}/>
                        </div>
                        
                    </div>
                    {
                        message && (
                            <div className="flex alert-success  px-4 py-6 mt-4 relative" role="alert">
                                <CheckCircleIcon className="w-6 mr-2 text-[#5BDB1F]" /> <span className="block sm:inline">{message}</span>
                            </div>
                        )
                    }
                    <div className="mt-[40px]">
                        <button 
                            type="button"
                            onClick={()=>onGenerateNewKeys('generateKeys', operationDetails)}
                            className="fontPageTitle color-alert-report bg-transparent font-bold uppercase px-6 py-2 
                        text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150">
                            Generate New Keys
                        </button>
                    </div>
                </div>
            </>
        )
    }


/*     const FormTransaction = () => {
        return (
            <>
                <div className="grid gap-6 m-[20px] md:grid-cols-2 ">
                    <div>
                        <label className="block mb-2 text-[14px]">Amount</label>
                        <div>
                            {(operationDetails?.cash_amount)? operationDetails?.cash_amount :''}
                        </div>
                    </div>
                    <div>
                        <label className="block mb-2 text-[14px]">Date</label>
                        <input 
                            type="text"
                            name="date" 
                            onChange={handleNameChange}
                            value={(operationDetails?.date)? operationDetails?.date :''} 
                            className="input-text fontPageTitle600 block w-full p-2.5" 
                            placeholder="" 
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-[14px]">Method</label>
                        <input 
                            type="text"
                            name="cashout" 
                            onChange={handleNameChange}
                            value={(operationDetails?.cashout)? operationDetails?.cashout :''} 
                            className="input-text fontPageTitle600 block w-full p-2.5" 
                            placeholder="" 
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-[14px]">Status</label>
                        <div>{operationDetails.status}</div>
                    </div>
                    <div>
                        <label className="block mb-2 text-[14px]">Country </label>
                        <div className="w-full ml-[10px]">{operationDetails?.country_withdraw}</div>
                    </div>
                    <div>
                        <label className="block mb-2 text-[14px]">ID Transaction </label>
                        <div className="w-full ml-[10px]">{operationDetails?.id}</div>
                    </div>
                </div>
            </>
        )
    } */

    const FormInvoice = () => {
        return (
            <>
            <div>
                <div className="grid grid-cols-2 w-full p-transaction">
                    <div className="col-span-1">
                        <p className="text-16">Transaction Details</p>
                    </div>
                    <div className="flex justify-end">
                        <div className="text-end">
                            <div className="flex items-center mb-2 text-14 w-full  mr-[10px]">
                                <div><span className="mr-[10px]">Status</span></div>
                                <div className={`w-[7.5rem] cursor-default badge bg-color-${operationDetails?.statusName?.toLowerCase()}`}>
                                    <span className={`fontPageTitle600`}>{stringMin(operationDetails?.statusName)}</span>
                                </div>
                            </div>
                        </div>
                        <div className="mr-[16px]">
                            <label className="flex items-center mb-2 text-14 w-full  mr-[16px]">
                                <div><span className="mr-[16px]">KYC</span></div>
                                <div className="w-full fontPageTitle600 badge bg-color-approved text-max-center">
                                    <span className={`fontPageTitle600`}>
                                        {operationDetails?.kyc ? 'Verified' : 'Not Verified'}
                                    </span>
                                </div>
                            </label>
                        </div>
                        <div></div>
                    </div>
                </div>
                <div className="grid gap-6 m-[20px] md:grid-cols-3 ">
                    <div>
                        <label className="block mb-2 text-14-500">Method</label>
                        <div className="text-14-111312-700">
                            {(operationDetails?.method)? operationDetails?.method :''}
                        </div>
                    </div>
                    <div>
                        <label className="block mb-2 text-14-500">Amount</label>
                        <div className="text-14-111312-700">
                            {(operationDetails?.amount)? operationDetails?.amount :''}
                        </div>
                    </div>
                    <div></div>
                    <div className="">
                        <label className="block mb-2 text-14-500">Country</label>
                        <div className="text-14-111312-700">
                            {operationDetails?.country} <span className="fontPageTitle600">{operationDetails?.countryName}</span>
                        </div>
                    </div>
                    <div className="">
                        <label className="block mb-2 text-14-500">From</label>
                        <div className="text-14-111312-700">
                            <span className="fontPageTitle600">{(operationDetails?.from)? operationDetails?.from :'N/A'}</span>
                        </div>
                    </div>
                    <div>
                        <label className="block mb-2 text-14-500">To</label>
                        <div className="text-14-111312-700">
                            <span className="fontPageTitle600">{(operationDetails?.to)? operationDetails?.to :'N/A'}</span>
                        </div>
                    </div>
{/*                     <div className="">
                        <label className="block mb-2 text-14-500">Currency pay</label>
                        <div className="text-14-111312-700">
                            <span className="fontPageTitle600">{(operationDetails?.currency)? operationDetails?.currency :''}</span>
                        </div>
                    </div>
                    <div>
                        <label className="block mb-2 text-14-500">Cashout Method</label>
                        <input 
                            type="text"
                            name="method" 
                            onChange={handleNameChange}
                            value={(operationDetails?.method)? operationDetails?.method :''} 
                            className="input-text fontPageTitle600 block w-full p-2.5" 
                            placeholder="" 
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-14-500">Payout time</label>
                        <input 
                            type="text"
                            name="time_payout" 
                            onChange={handleNameChange}
                            value={(operationDetails?.time_payout)? operationDetails?.time_payout :''} 
                            className="input-text fontPageTitle600 block w-full p-2.5" 
                            placeholder="" 
                        />
                        <span className="text-14-500">Estimated time of payout: <b>{operationDetails?.time_estimate_payout}</b></span>
                    </div> */}

                </div>
                <div className="grid gap-6 m-[20px]">
                    <p className="text-17-700">User Details</p>
                </div>
                <div className="grid gap-6 grid-cols-3 m-[20px]">
                    <div>
                        <label className="block mb-2 text-14-500">Name</label>
                        <div className="text-14-111312-700">
                            {(operationDetails?.name)? operationDetails?.name :''}
                        </div>
                    </div>
                    <div>
                        <label className="block mb-2 text-14-500">Phone number</label>
                        <div className="text-14-111312-700">
                            {(operationDetails?.phoneNumber)? operationDetails?.phoneNumber :'N/A'}
                        </div>
                    </div>
                    <div></div>
                    <div className="">
                        <label className="block mb-2 text-14-500">Email</label>
                        <div className="text-14-111312-700">
                            {(operationDetails?.email)? operationDetails?.email :'N/A'}
                        </div>
                    </div>
                </div>
                <div className="w-auto flex gap-11 m-[10px] mb-[40px]">
                    <div className="sm:w-full md:w-[10%]"> 
                        <label className="block mb-[11px] ml-[10px] text-12"> Date </label>
                        <p className="ml-[10px] text-14-400-000">{operationDetails?.enddateNew}</p>
                    </div>
{/*                     <div className="sm:w-full md:w-[45%]">
                        <label className="block mb-2 ml-[10px] text-12"> Invoice ID </label>
                        <div className="ml-[10px] text-16">{operationDetails.id}</div>
                    </div> */}
                    <div className="sm:w-full md:w-[54%]">
                        <label className="block mb-2 ml-[10px] text-12">Transaction ID </label>
                        <div className="ml-[10px] text-16">{operationDetails.id}</div>
                    </div>
                    <div className="self-center">
                        <button
                            className="btn-report"
                            type="button"
                            onClick={() => onSectionForm('report-1')}
                        >
                            <div className="flex font-size-12">
                                <div><ExclamationTriangleIcon className='mr-2 color-alert w-[1.5rem] color-Logout cursor-pointer' /></div>
                                <div className="font-size-12">Report</div>
                            </div> 
                        </button>
                    </div>
                </div>
            </div>
            </>
        )
    }

    const FormRoleUser = (props: any) => {

        const { onsubmitModal } =  props;
        const business = useSelector((state: any) => state.business);
        const [input, setInput] = useState<any>({
            email:'',
            name:'',
            phone:'',
            password:'',
            role:'',
            IdBusiness:business.id.toString(),
            owner:'x',
        });

        const [valueRoles, setValueRoles] = useState({
            optionValues : Object.values(userBusinessRoles)
        });

        const handleSubmit = (event: any)=>{
            event.preventDefault();
            onsubmitModal(input);
        }

        const onValueSelect = (event: any, name: any) =>{
            setInput((prevProps : any)=>({
                ...prevProps,
                [name] : event
            }))
        }

        const handleChange = (event: any) =>{
            setInput((prevProps: any)=>({
                ...prevProps,
                [event.target.name] : event.target.value
            }))
        }



        return (
            <>
                <div className="w-[500px] p-4 ">
                    <form className="grid grid-cols-1 py-6 gap-8 w-full" onSubmit={handleSubmit}>
                        <div className="flex flex-col gap-2">
                            <label className="text-[14px]" htmlFor="">Name</label>
                            <input
                                name="name"
                                className="w-full p-2.5 border-input"
                                required
                                type="text"
                                onChange={handleChange}
                                value={input.name}
                            />
                        </div>

                        <div className="flex flex-col gap-2">
                            <label className="text-[14px]" htmlFor="">Email</label>
                            <input
                                name="email"
                                className="w-full p-2.5 border-input"
                                required
                                type="email"
                                pattern={String(RegExpValidator.email)}
                                onChange={handleChange}
                                value={input.email}
                            />
                        </div>

                        <DropdownList nameInput="role" labelName={'Select Role'} onValueData={onValueSelect} dataOption={valueRoles.optionValues} />

                        <div className="flex justify-center">
                            <button type="submit" className="btn-upload-submit">Send Invite</button>
                        </div>
                    </form>
                </div>
            </>
        )
    }

    const closeDialog = (isActive: boolean) => {
        closeModal(isActive);
        setActionForm(actionForm);
    }

    return (
        <>
        {isOpen ? (
            <>
            <div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            > 
                <div className="relative w-auto my-6 mx-auto max-w-7xl">
                {/*content*/}
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full 
                bg-white outline-none focus:outline-none">
                    {/*header*/}
                    {
                        ['info', 'Details Developers', 'transactions', 'invoice', 'addRoleUser'].includes(typeOperation) && (
                            <HeadInfo closeDialog={closeDialog} titleHead={typeOperation}/>
                        )
                    }
                    {
                        'report-1'.includes(typeOperation) && (
                            <HeadReport closeDialog={closeDialog} onPreviuse={onPreviuse} />
                        )
                    }

                    {/*body*/}
                    {
                        'info'.includes(typeOperation) && (
                            <FormTransactionDetails onSectionForm={onSectionForm}/>
                        )
                    }
                    {
                        'report-1'.includes(typeOperation) && (
                            <FormReporttransaction onSectionForm={onSectionForm}/>
                        )
                    }
                    {
                        'Details Developers'.includes(typeOperation) && (
                            <FormDatilsDev onGenerateNewKeys={onGenerateNewKeys}/>
                        )
                    }
{/*                     {
                        'transactions'.includes(typeOperation) && (
                            <FormTransaction />
                        )
                    } */}
                    {
                        ['invoice', 'transactions'].includes(typeOperation) && (
                            <FormInvoice />
                        )
                    }
                    {
                        'addRoleUser'.includes(typeOperation) && (
                            <FormRoleUser onsubmitModal={onsubmitModal} />
                        )
                    }
  
                    {/*footer*/}
{/*                     <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                        <button
                            className="text-red-500 bg-transparent font-bold uppercase px-6 py-2 
                            text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                            type="button"
                            onClick={() => closeModal(false)}
                        >
                            Close
                        </button>
                    </div> */}
                </div>
                </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </>
        ) : null}
        </>
    );
}
